// Attach a `mention` static property to a tool function component
// matching the `ToolComponent` interface used in prose references
// (e.g. `AtlasInstructions.tsx` rendering `${MyTool.mention}` as a
// backtick-wrapped tool name in instructions text).
//
// The new `<Tool>` component sets `.mention` on its inner `ToolImpl`
// — that's the component AUI mounts, but it's not the symbol authors
// export. This helper closes the gap by tagging the outer function
// with the same value, so consumers can read `XyzTool.mention` without
// touching the AUI internals.

type WithMention<F> = F & { readonly mention: string };

export function withMention<F extends (...args: never) => unknown>(name: string, fn: F): WithMention<F> {
  Object.defineProperty(fn, 'mention', { value: `\`${name}\``, writable: false, enumerable: false });
  return fn as WithMention<F>;
}
